// export const API_URL = "http://169.254.10.254:3002"
// export const API_URL = "http://108.55.14.210:3002"
// export const API_URL = "http://192.168.11.147:3002"
// export const API_URL = "http://localhost:3000"
// export const API_URL = "http://api.pooledtrust.lenalevinestudio.com"

// export const API_URL = "http://192.168.1.16.:3002"

export const API_URL = 'https://api.elderjusticeny.org';
// export const API_URL = 'https://api.elderjusticeny.org';